<template>
    <div class="form-recommend">
        <form action="" @submit.prevent="handleSubmit" class="relative">
            <div class="form__head">
                <h3>Consiglia alla tua scuola un libro da inserire in biblioteca</h3>
            </div>

            <div class="form__body">
                <div class="form__row">
                    <base-input
                        id="field-title"
                        placeholder="Titolo"
                        v-model="form.title"
                        :required="true"
                    />
                </div>

                <div class="form__row">
                    <base-input
                        id="field-author"
                        placeholder="Autore"
                        v-model="form.author"
                        :required="true"
                    />
                </div>

                <div class="form__row">
                    <base-input
                        id="field-publisher"
                        placeholder="Casa editrice"
                        v-model="form.publisher"
                        :required="true"
                    />
                </div>

                <div class="form__row">
                    <base-input
                        id="field-motivation"
                        placeholder="Perchè lo consiglio"
                        v-model="form.motivation"
                        :required="true"
                    />
                </div>

            </div>

            <div class="form__actions">
                <slot name="cancelBtn" />

                <button type="submit" class="form__btn btn btn--primary">
                    Consiglia
                </button>
            </div>
        </form>
    </div>
</template>

<script>
import { ref } from 'vue';
import BaseInput from '@/components/base-input/base-input';

export default {
    name: 'FormRecommend',

    components: {
        BaseInput
    },

    setup(_ , { emit }) {
        const form = ref({
            title: '',
            author: '',
            publisher: '',
            motivation: ''
        });

        const handleSubmit = () => {
            emit('on-submit', form.value);
        };

        return {
            handleSubmit,
            form
        }
}

}
</script>

<style>

</style>
